<template>
  <div class="one-column-view">
    <div class="article-content">
      <img src="../../assets/beta.png" alt="Join Beta" />
      <h1>加入Goldenlink+ Beta计划</h1>
      <p>参与我们的社区QA活动，您将通过以下方式获得GCoins和代币奖励：</p>
      <ol>
        <li>在GoldenLink+应用程序上注册加入。</li>
        <li><strong>加入“Bug跟踪社区”</strong></li>
        <li>
          开始您的社区活动，特别关注您使用应用程序时的用户体验，一旦发现任何不好的体验，包括任何Bug，不要等待，第一时间截图发布到我们的Bug跟踪社区，并在文中指出问题所在，以及您的建议和感受。
        </li>
        <li>
          关于奖励：我们将逐一审查这些反馈内容。注意：如果您是第一个发现问题的人，如果系统认可您的发现，您将是该发现的唯一获奖者。
        </li>
        <li>
          额外奖励：如果我们批准您的错误报告是正确的。每个报告的错误将奖励您200个金币。没有限制。押注60天后，您的奖励将翻倍。如果您申请成为黄金矿工，那么60天后您将再获得400
          GCoins奖励。
        </li>
        <li>
          有两种收入奖励，即GCoins和代币。在证明押注（POS）后，您就可以兑现您的GCoins。代币将被锁定，等待系统完成。
        </li>
      </ol>
      <div class="w-100 w-md-50">
        <DownloadApp />
      </div>
    </div>
  </div>
</template>

<script>
import DownloadApp from "@/components/DownloadApp.vue";

export default {
  components: {
    DownloadApp,
  },
};
</script>

<style scoped></style>
